<template>
  <header class="header-container">
    <div class="header-titles">
      <h2 v-if="$slots.subtitle"><slot name="subtitle"></slot></h2>

      <h3 v-if="$slots.default"><slot></slot></h3>

      <h3 class="project-title" v-if="$slots.project">
        <slot name="project"></slot>
      </h3>

      <h3 class="modal-title" v-if="$slots['modal-title']">
        <slot name="modal-title"></slot>
      </h3>

      <h4 v-if="$slots['lower-subtitle']">
        <slot name="lower-subtitle"></slot>
      </h4>
    </div>
    <div class="header-close" v-if="modalButton">
      <button
        type="button"
        @click.passive="$emit('close-modal')"
        aria-label="close modal"
      >
        <img :src="closeIconSrc" alt="close button" />
      </button>
    </div>
  </header>
</template>

<script>
import closeIcon from "@/images/closeIcon.svg";

export default {
  name: "VHeader",
  data() {
    return {
      closeIconSrc: closeIcon,
    };
  },
  props: {
    modalButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.header-titles > h2 {
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-400);
}
.header-titles > h4 {
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-400);
}
.header-titles > h3 {
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-400);
  line-height: normal;
}
.header-titles > .project-title {
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-400);
  line-height: normal;
}
h3.modal-title {
  font-size: var(--font-size-200);
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header-titles {
  display: flex;
  flex-direction: column;
  font-family: var(--font-system-ui);
}

div.header-close > button {
  cursor: pointer;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  outline: inherit;
}
</style>
